(function() {

  if (window.innerWidth <= 768) {

    function killOtherFilterBars() {
      var opener = document.getElementById('diamond-filter-opener');
      var drawer = document.getElementById('rsmobile-filter');
      // Our own custom mobile Filters button (id=sd-mfilter-btn) is the
      // ONE filter bar we want to KEEP — never tag it as sp-native-killed.
      var ourBtn = document.getElementById('sd-mfilter-btn');
      // Our own mobile drawer aside (#sd-side) and trigger (#sd-mfilter-btn)
      // must NEVER be tagged or have their ancestors tagged — the drawer header
      // contains the literal text "Filters" which would otherwise match the kill
      // heuristic and walk up to find the fixed-position drawer aside, killing it.
      var ourSide = document.getElementById('sd-side');
      document.querySelectorAll('button, a, span, div').forEach(function(el) {
        if (!el || el.id === 'diamond-filter-opener') return;
        if (el.id === 'sd-mfilter-btn') return;
        if (el.id === 'sd-side') return;
        if (el.closest && el.closest('#diamond-filter-opener')) return;
        if (el.closest && el.closest('#sd-mfilter-btn')) return;
        if (el.closest && el.closest('#sd-side')) return;
        if (el.closest && el.closest('#rsmobile-filter')) return;
        if (opener && el.contains && el.contains(opener)) return;
        if (ourBtn && el.contains && el.contains(ourBtn)) return;
        if (ourSide && el.contains && el.contains(ourSide)) return;
        if (drawer && el.contains && el.contains(drawer)) return;
        if (el.children && el.children.length > 3) return;
        var t = (el.textContent || '').trim().toUpperCase()
          .replace(/\s+/g, ' ').replace(/[▾▼∨↓↑↥↧⌃⌄]/g, '').trim();
        if (t.length > 24) return;
        if (t !== 'SORT BY' && t !== 'SORT' && t !== 'FILTERS' && t !== 'FILTER' &&
            t.indexOf('SORT BY') !== 0 && t.indexOf('FILTERS') !== 0) return;
        var p = el, hops = 0, killed = false;
        while (p && p !== document.body && hops < 6) {
          if (p.id === 'diamond-filter-opener' || (p.closest && p.closest('#diamond-filter-opener'))) return;
          if (p.id === 'sd-side' || (p.closest && p.closest('#sd-side'))) return;
          if (p.id === 'rsmobile-filter' || (p.closest && p.closest('#rsmobile-filter'))) return;
          if (opener && p.contains && p.contains(opener)) return;
          if (ourSide && p.contains && p.contains(ourSide)) return;
          if (drawer && p.contains && p.contains(drawer)) return;
          var cs = getComputedStyle(p);
          if (cs.position === 'fixed' || cs.position === 'sticky') {
            p.classList.add('sp-native-killed');
            killed = true;
            return;
          }
          p = p.parentElement;
          hops++;
        }
        if (!killed) el.classList.add('sp-native-killed');
      });
    }

    function watchDrawer() {
      var drawer = document.getElementById('rsmobile-filter');
      if (!drawer) return;
      function sync() {
        if (drawer.classList.contains('has--append')) document.body.classList.add('sp-drawer-open');
        else document.body.classList.remove('sp-drawer-open');
      }
      sync();
      if ('MutationObserver' in window) {
        new MutationObserver(sync).observe(drawer, { attributes: true, attributeFilter: ['class'] });
      }
    }

    function rebrandHeader() {
      var drawer = document.getElementById('rsmobile-filter');
      if (!drawer) return;
      var h = drawer.querySelector('.mobile-filter-header h3, .section-header-reverse');
      if (h && !h.dataset.spRebranded) {
        h.textContent = 'Refine';
        h.dataset.spRebranded = '1';
      }
    }

    /* v49: physically unwrap #filter__shape out of the 1fr-2fr grid wrapper */
    function unwrapShapeSection() {
      var drawer = document.getElementById('rsmobile-filter');
      if (!drawer || drawer.dataset.spUnwrapped === '1') return;
      var wrapper = drawer.querySelector('.filter__grid-1fr-2fr-wrapper');
      var shape = drawer.querySelector('#filter__shape');
      if (!wrapper || !shape) return;
      var title = wrapper.querySelector(':scope > .filter__title, :scope > .sp-shape-label');
      // Find a good anchor — just before the wrapper, inserted at top of drawer content body
      // (mobile-filter-header is absolutely positioned so we can simply prepend)
      var firstChild = drawer.firstElementChild;
      // Move the shape section to be drawer's first content child (after header which is absolute)
      drawer.insertBefore(shape, firstChild);
      if (title) drawer.insertBefore(title, shape);
      // Hide the now-empty wrapper
      wrapper.classList.add('sp-empty-wrapper');
      drawer.dataset.spUnwrapped = '1';
    }

    function wireAutoApply() {
      var drawer = document.getElementById('rsmobile-filter');
      if (!drawer || drawer.dataset.spAutoApply === '1') return;
      drawer.dataset.spAutoApply = '1';
      var timer = null;
      function fire() {
        clearTimeout(timer);
        timer = setTimeout(function() {
          var btn = drawer.querySelector('.apply-filter, .btn.apply-filter');
          if (btn) {
            try { btn.click(); } catch(e){}
            try { btn.dispatchEvent(new Event('click', { bubbles: true })); } catch(e){}
          }
        }, 280);
      }
      drawer.addEventListener('change', fire, true);
      drawer.addEventListener('click', function(e) {
        var t = e.target;
        if (!t) return;
        if (t.closest && (t.closest('.shape.filter__item') || t.closest('.text-box.filter__item'))) fire();
      }, true);
    }

    function injectApplyBtn() {
      var drawer = document.getElementById('rsmobile-filter');
      if (!drawer || drawer.querySelector('.sp-apply-btn')) return;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'sp-apply-btn';
      btn.textContent = 'Apply Filters';
      btn.addEventListener('click', function() {
        var close = drawer.querySelector('.mm-close');
        if (close) close.click();
      });
      drawer.appendChild(btn);
    }

    function installBackdrop() {
      if (document.getElementById('sp-drawer-backdrop')) return;
      var bd = document.createElement('div');
      bd.id = 'sp-drawer-backdrop';
      bd.style.cssText = 'position:fixed;inset:0;background:rgba(10,29,46,.38);z-index:99998;display:none;';
      bd.addEventListener('click', function() {
        var drawer = document.getElementById('rsmobile-filter');
        var close = drawer && drawer.querySelector('.mm-close');
        if (close) close.click();
      });
      document.body.appendChild(bd);
      var drawer = document.getElementById('rsmobile-filter');
      if (!drawer) return;
      function sync() { bd.style.display = drawer.classList.contains('has--append') ? 'block' : 'none'; }
      sync();
      if ('MutationObserver' in window) {
        new MutationObserver(sync).observe(drawer, { attributes: true, attributeFilter: ['class'] });
      }
    }

    function run() {
      try { killOtherFilterBars(); } catch(e) {}
      try { watchDrawer(); } catch(e) {}
      try { rebrandHeader(); } catch(e) {}
      try { unwrapShapeSection(); } catch(e) {}
      try { wireAutoApply(); } catch(e) {}
      try { installBackdrop(); } catch(e) {}
      try { injectApplyBtn(); } catch(e) {}
    }
    function ready(fn) {
      if (document.readyState === 'complete' || document.readyState === 'interactive') setTimeout(fn, 0);
      else document.addEventListener('DOMContentLoaded', fn);
    }
    ready(function() {
      run();
      setTimeout(run, 500);
      setTimeout(run, 1500);
      setTimeout(run, 3000);
      setInterval(killOtherFilterBars, 4000);
    });
    return;
  }

  var STANDARD  = ['round','princess','oval','cushion','emerald','pear','asscher','marquise','radiant','heart'];
  var SPECIALTY = ['portuguese','moval','long cushion','antique cuts','dutch marquise','french marquise','elongated hexagon'];
  function nm(s){ return (s||'').trim().toLowerCase(); }
  function fmtMoney(n) { if (n >= 1000) { var k = n/1000; return '$' + (k%1===0 ? k : k.toFixed(1)) + 'k'; } return '$' + Math.round(n); }
  function fmtCarat(n) { return n.toFixed(2); }

  function splitShapes() {
    var c = document.querySelector('#filter__shape .filter-shapes');
    if (!c || c.querySelector('.sp-ld-shape-heading')) return;
    var tiles = [].slice.call(c.querySelectorAll('.shape.filter__item'));
    if (!tiles.length) return;
    var std = [], spec = [], other = [];
    tiles.forEach(function(t){
      var v = nm(t.getAttribute('data-value') || t.getAttribute('data-handle'));
      if (STANDARD.indexOf(v) !== -1) std.push(t);
      else if (SPECIALTY.indexOf(v) !== -1) spec.push(t);
      else other.push(t);
    });
    std.sort(function(a,b){ return STANDARD.indexOf(nm(a.getAttribute('data-value'))) - STANDARD.indexOf(nm(b.getAttribute('data-value'))); });
    spec.sort(function(a,b){ return SPECIALTY.indexOf(nm(a.getAttribute('data-value'))) - SPECIALTY.indexOf(nm(b.getAttribute('data-value'))); });
    while (c.firstChild) c.removeChild(c.firstChild);
    if (std.length)  { var h1=document.createElement('h3');h1.className='sp-ld-shape-heading';h1.textContent='Standard Shapes';c.appendChild(h1);std.forEach(function(t){c.appendChild(t);}); }
    if (spec.length) { var h2=document.createElement('h3');h2.className='sp-ld-shape-heading';h2.textContent='Specialty Shapes';c.appendChild(h2);spec.forEach(function(t){c.appendChild(t);}); }
    other.forEach(function(t){c.appendChild(t);});
  }

  function addSpecialtyPills() {
    document.querySelectorAll('.diamond-card').forEach(function(card){
      if (card.querySelector('.sp-specialty-pill')) return;
      var shapeEl = card.querySelector('.diamond-shape, .mobile-shape');
      if (!shapeEl) return;
      var shape = nm(shapeEl.textContent);
      if (SPECIALTY.indexOf(shape) === -1) return;
      var img = card.querySelector('.image-box');
      if (!img) return;
      var pill = document.createElement('span');
      pill.className = 'sp-specialty-pill';
      pill.innerHTML = '<span class="sp-specialty-pill__star">★</span> Rare Find';
      img.appendChild(pill);
    });
  }

  var NATIVE_ID = { color:'filter__color', clarity:'filter__clarity', carat:'filter__carat', cut:'filter__cut', price:'filter__price' };
  function getNativeSlider(key) {
    var parent = document.getElementById(NATIVE_ID[key]);
    if (!parent) return null;
    var slider = parent.querySelector('.range-slider');
    if (!slider || !slider.noUiSlider) return null;
    return { parent: parent, slider: slider };
  }
  function fireAll(el, events) { events.forEach(function(n){ try { el.dispatchEvent(new Event(n,{bubbles:true})); } catch(e){} }); }
  function syncToNative() {
    var jq = window.jQuery || window.$;
    Object.keys(NATIVE_ID).forEach(function(key){
      var native = getNativeSlider(key); if (!native) return;
      var slider = native.slider; var range;
      try { range = slider.noUiSlider.options.range; } catch(e){ return; }
      var st = state[key];
      var lo = st.touched ? Math.max(range.min, Math.min(st.min, range.max)) : range.min;
      var hi = st.touched ? Math.max(range.min, Math.min(st.max, range.max)) : range.max;
      try { slider.noUiSlider.set([lo, hi], true, true); } catch(e) { try { slider.noUiSlider.set([lo, hi]); } catch(e2){} }
      var startInp = native.parent.querySelector('.slider-start-value');
      var endInp = native.parent.querySelector('.slider-end-value');
      var fmt = function(n){ return (typeof n === 'number') ? n.toFixed(2) : n; };
      if (startInp) { startInp.value = fmt(lo); fireAll(startInp,['input','change','keyup','blur']); if (jq) { try { jq(startInp).trigger('change').trigger('keyup').trigger('blur'); } catch(e){} } }
      if (endInp)   { endInp.value   = fmt(hi); fireAll(endInp,['input','change','keyup','blur']);   if (jq) { try { jq(endInp).trigger('change').trigger('keyup').trigger('blur'); } catch(e){} } }
      if (jq) { try { jq(slider).trigger('change'); } catch(e){} }
      fireAll(slider,['change']);
    });
  }
  var syncT=null; function scheduleSyncToNative(){ clearTimeout(syncT); syncT=setTimeout(syncToNative, 280); }

  var COLORS=['K','J','I','H','G','F','E','D'], CLARITY=['SI2','SI1','VS2','VS1','VVS2','VVS1','IF','FL'], CUT=['Good','Very Good','Excellent','Ideal'];
  var SLIDERS = {
    price:  { type:'continuous', min:100,  max:17000, step:50,   initMin:100,  initMax:17000 },
    carat:  { type:'continuous', min:0.30, max:15.00, step:0.01, initMin:0.30, initMax:15.00 },
    cut:    { type:'discrete', values:CUT,     initMin:0, initMax:CUT.length-1 },
    color:  { type:'discrete', values:COLORS,  initMin:0, initMax:COLORS.length-1 },
    clarity:{ type:'discrete', values:CLARITY, initMin:0, initMax:CLARITY.length-1 }
  };
  var state = {};
  Object.keys(SLIDERS).forEach(function(k){ state[k] = { min:SLIDERS[k].initMin, max:SLIDERS[k].initMax, touched:false }; });

  function buildBar() {
    var wrap = document.querySelector('.diamond-filter__container');
    if (!wrap || wrap.querySelector('.sp-ld-block')) return;
    var block = document.createElement('div'); block.className = 'sp-ld-block';
    var frame = document.createElement('div'); frame.className = 'sp-bn-frame';
    frame.innerHTML =
      '<button type="button" class="sp-bn-clear" id="sp-bn-clear">Clear all</button>' +
      '<div class="sp-bn">' +
        sliderColHTML('price','Price') + sliderColHTML('carat','Carat') + sliderColHTML('cut','Cut') +
        sliderColHTML('color','Color') + sliderColHTML('clarity','Clarity') + '</div>';
    block.appendChild(frame);
    var advBtn = document.createElement('button');
    advBtn.type='button'; advBtn.className='sp-ld-advanced-toggle'; advBtn.textContent='Advanced Quality Specs';
    block.appendChild(advBtn);
    var advPanel = document.createElement('div'); advPanel.className='sp-ld-advanced-panel';
    block.appendChild(advPanel);
    ['.filter__polish','.filter__symmetry','.filter__fluorescence','.filter__lw','.filter__depth','.filter__table'].forEach(function(sel){
      var el = document.querySelector(sel); if (el) advPanel.appendChild(el);
    });
    advBtn.addEventListener('click', function(){ block.classList.toggle('sp-ld-advanced-open'); });
    var shapeWrapper = wrap.querySelector('.filter__grid-1fr-2fr-wrapper');
    if (shapeWrapper && shapeWrapper.parentElement === wrap) {
      if (shapeWrapper.nextSibling) wrap.insertBefore(block, shapeWrapper.nextSibling);
      else wrap.appendChild(block);
    } else { wrap.appendChild(block); }
    Object.keys(SLIDERS).forEach(function(k){ initSlider(k); });
    document.getElementById('sp-bn-clear').addEventListener('click', function(){
      Object.keys(SLIDERS).forEach(function(k){
        state[k].min = SLIDERS[k].initMin; state[k].max = SLIDERS[k].initMax; state[k].touched = false;
        var col = document.querySelector('.sp-bn__col[data-key="'+k+'"]');
        if (col) {
          var minH = col.querySelector('.sp-rng__handle--min'); var maxH = col.querySelector('.sp-rng__handle--max');
          if (minH && maxH) { minH.value = SLIDERS[k].initMin; maxH.value = SLIDERS[k].initMax; }
          updateSliderUI(k);
        }
      });
      scheduleSyncToNative();
    });
  }
  function sliderColHTML(key, title) {
    var s = SLIDERS[key]; var ticksHTML='';
    if (s.type==='discrete') {
      ticksHTML = '<div class="sp-bn__ticks" data-ticks="'+key+'">' + s.values.map(function(v,i){ return '<span class="sp-bn__tick" data-i="'+i+'">'+v+'</span>'; }).join('') + '</div>';
    } else {
      var loFmt, hiFmt;
      if (key==='price')      { loFmt = fmtMoney(s.min); hiFmt = fmtMoney(s.max) + '+'; }
      else if (key==='carat') { loFmt = fmtCarat(s.min) + ' ct'; hiFmt = fmtCarat(s.max) + '+ ct'; }
      ticksHTML = '<div class="sp-bn__bounds"><span>'+loFmt+'</span><span>'+hiFmt+'</span></div>';
    }
    var stepAttr = (s.type==='discrete') ? 1 : (s.step || 1);
    var minAttr = (s.type==='discrete') ? 0 : s.min;
    var maxAttr = (s.type==='discrete') ? (s.values.length - 1) : s.max;
    return '<div class="sp-bn__col" data-key="'+key+'">' +
      '<div class="sp-bn__label">'+title+'</div><div class="sp-bn__value" data-value="'+key+'"></div>' +
      '<div class="sp-rng"><div class="sp-rng__track"></div><div class="sp-rng__fill"></div>' +
        '<input type="range" class="sp-rng__handle sp-rng__handle--min" min="'+minAttr+'" max="'+maxAttr+'" step="'+stepAttr+'" value="'+s.initMin+'">' +
        '<input type="range" class="sp-rng__handle sp-rng__handle--max" min="'+minAttr+'" max="'+maxAttr+'" step="'+stepAttr+'" value="'+s.initMax+'">' +
      '</div>' + ticksHTML + '</div>';
  }
  function initSlider(key) {
    var col = document.querySelector('.sp-bn__col[data-key="'+key+'"]'); if (!col) return;
    var minH = col.querySelector('.sp-rng__handle--min'); var maxH = col.querySelector('.sp-rng__handle--max');
    function onChange(){
      var lo = parseFloat(minH.value); var hi = parseFloat(maxH.value);
      // v60 (2026-04-21): allow min === max so users can pin a single value
      // (e.g., just D for color, just IF for clarity) without forced spread.
      if (lo > hi) {
        if (this === minH) lo = hi; else hi = lo;
        minH.value = lo; maxH.value = hi;
      }
      state[key].min = lo; state[key].max = hi;
      state[key].touched = (lo > SLIDERS[key].initMin) || (hi < SLIDERS[key].initMax);
      updateSliderUI(key); scheduleSyncToNative();
    }
    minH.addEventListener('input', onChange); maxH.addEventListener('input', onChange);
    updateSliderUI(key);
  }
  function updateSliderUI(key) {
    var s = SLIDERS[key]; var col = document.querySelector('.sp-bn__col[data-key="'+key+'"]'); if (!col) return;
    var st = state[key]; var fill = col.querySelector('.sp-rng__fill');
    var range, lo, hi;
    if (s.type==='discrete') { range = (s.values.length - 1) || 1; lo = (st.min/range)*100; hi = (st.max/range)*100; }
    else { range = s.max - s.min; lo = ((st.min - s.min)/range)*100; hi = ((st.max - s.min)/range)*100; }
    fill.style.left = lo+'%'; fill.style.right = (100-hi)+'%';
    var disp = col.querySelector('[data-value="'+key+'"]');
    if (disp) {
      if (!st.touched) { disp.innerHTML = '<span style="font-style:italic;color:var(--sp-mute);">All</span>'; }
      else if (s.type==='discrete') {
        var lbl1 = s.values[Math.round(st.min)]; var lbl2 = s.values[Math.round(st.max)];
        disp.innerHTML = (lbl1===lbl2) ? lbl1 : (lbl1 + '<span class="sp-bn__value-dash">—</span>' + lbl2);
      } else if (key==='price') {
        disp.innerHTML = fmtMoney(st.min) + '<span class="sp-bn__value-dash">—</span>' + fmtMoney(st.max) + (st.max >= s.max ? '+' : '');
      } else if (key==='carat') {
        disp.innerHTML = fmtCarat(st.min) + '<span class="sp-bn__value-dash">—</span>' + fmtCarat(st.max) + '<span class="sp-bn__value-unit">ct</span>';
      }
    }
    if (s.type==='discrete') {
      var ticks = col.querySelectorAll('[data-ticks="'+key+'"] .sp-bn__tick');
      ticks.forEach(function(t,i){ var inRange = i >= Math.round(st.min) && i <= Math.round(st.max); t.classList.toggle('is-in', inRange && st.touched); });
    }
  }

  function run() {
    try { splitShapes(); } catch(e){}
    try { buildBar(); } catch(e){}
    try { addSpecialtyPills(); } catch(e){}
  }
  function ready(fn) {
    if (document.readyState === 'complete' || document.readyState === 'interactive') setTimeout(fn, 0);
    else document.addEventListener('DOMContentLoaded', fn);
  }
  ready(function() {
    run(); setTimeout(run, 500); setTimeout(run, 2000);
    var wrapper = document.querySelector('.diamond-filter__wrapper');
    var rafP = false;
    function sched(){ if (rafP) return; rafP = true; requestAnimationFrame(function(){ rafP = false; run(); }); }
    if (wrapper && 'MutationObserver' in window) {
      new MutationObserver(function(muts){
        var allOurs = muts.length > 0 && muts.every(function(m){ var t = m.target; return t && t.nodeType === 1 && t.closest && t.closest('.sp-ld-block'); });
        if (!allOurs) sched();
      }).observe(wrapper, { childList: true, subtree: true });
    }
  });
})();
